import { render, staticRenderFns } from "./addChangeInfo.vue?vue&type=template&id=889aaf36&scoped=true&"
import script from "./addChangeInfo.vue?vue&type=script&lang=js&"
export * from "./addChangeInfo.vue?vue&type=script&lang=js&"
import style0 from "./addChangeInfo.vue?vue&type=style&index=0&id=889aaf36&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889aaf36",
  null
  
)

export default component.exports